import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import { useWindowSize } from '@brands/hooks';
import { useSnackbar } from '@brands/hooks/useStackbar';
import { listAllLanguages } from '@brands/services/identity/listAllLanguages';
import { OptionLanguage } from '@brands/Utils/selectOptions';
import React, { Fragment, useEffect, useState } from 'react';

import Container from '../../../../Components/Container/Container';
import EditDependent from '../../../MyProfile/Patient/Sections/Dependent/EditDependent';
import styles from './styles.module.scss';

const AddNewDependent = (): JSX.Element => {
  const screenSize = useWindowSize();
  const [isEditDependent, setIsEditDependent] = useState(false);
  const [languageOptions, setLanguageOptions] = useState<OptionLanguage[]>([]);
  const [validationResponseId, setValidationResponseId] = useState('');
  const [showDeleteDependentConfirmationModal, setShowDeleteDependentConfirmationModal] = useState(false);
  const { showSnackbar } = useSnackbar();

  const fetchLanguageOptions = async (): Promise<void> => {
    const data = await listAllLanguages();
    const transformedData = data.map((language) => ({
      value: language.locale,
      label: language.name,
      id: language.id,
    }));
    setLanguageOptions(transformedData);
  };

  useEffect(() => {
    fetchLanguageOptions();
  }, []);
  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.patientFormContainer}`}>
        <PatientIntakeNavigation progress={4} />
        <EditDependent
          setIsEditDependent={setIsEditDependent}
          dependentId={0}
          languageOptions={languageOptions}
          validationResponseId={validationResponseId}
          setValidationResponseId={setValidationResponseId}
          isFromSelectNeeds={false}
          showDeleteDependentConfirmationModal={showDeleteDependentConfirmationModal}
          setShowDeleteDependentConfirmationModal={setShowDeleteDependentConfirmationModal}
          showSnackbar={showSnackbar}
          isFromPatientIntake
        />
      </div>
    </Container>
  );
};
export default AddNewDependent;
